<template>
  <div class="company-settings" v-loading="loading">

    <div
      v-if="$canAndRulesPass(user, $permissions.SETTING.UPDATE)"
    >
      <div>
        Коэффициент для минимальной границы диапазона выплат:
        <el-input
          style="width: 100px"
          size="mini"
          type="number"
          :value="settings.weight_fact_range_min"
          @input="updateSettingValue('weight_fact_range_min', $event)"
          @change="saveSettingValue('weight_fact_range_min', $event)"
        >
        </el-input>
      </div>

      <div style="margin-top: 20px">
        Коэффициент для максимальной границы диапазона выплат:
        <el-input
          style="width: 100px"
          size="mini"
          type="number"
          :value="settings.weight_fact_range_max"
          @input="updateSettingValue('weight_fact_range_max', $event)"
          @change="saveSettingValue('weight_fact_range_max', $event)"
        >
        </el-input>
      </div>
    </div>


  </div>
</template>

<script>

import {companySettings} from "@/mixins/companySettings";
import {downloader} from "@/mixins/downloader";
import ImportModal from "@/components/exportImport/ImportModal.vue";
import {mapGetters} from "vuex";

export default {
  name: "company-settings",
  components: {ImportModal},
  mixins: [companySettings],

  props: {},
  computed: {
    ...mapGetters(['user']),
  },
  data() {
    return {}
  },
  mounted() {
  },
  methods: {
  }
}
</script>


<style lang="scss">

</style>